import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import GetStartedPage from './pages/GetStartedPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ContactUsPage from './pages/ContactUsPage';
import BlogPage from './pages/BlogPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/get-started" element={<GetStartedPage />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/blog/:blogId?" element={<BlogPage />} />
      </Routes>
    </Router>
  );
}

export default App;